module.exports = __webpack_public_path__ + "static/media/lookerActive.0015228a.svg";